import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const PlusIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", width: sizePx, style: styles, ...rest },
        React.createElement("path", { d: "M3 9.8h6.7M14.3 9.8h2M10 16.8V3", stroke: color, strokeWidth: "2", strokeLinecap: "round" })));
};
export default PlusIcon;
//# sourceMappingURL=index.js.map